// @flow
import type {
  MessageGroupListItem,
  MessageGroupShort,
  MessageGroup,
  MessageGroupViewItem,
} from "../components/MessageGroupsList/types/MessageGroupsList.types";
import type { BrowserLanguage } from "../containers/CreateMessageGroup";
import type { MessageListItem } from "../components/MessagesList/types/MessagesList.types";

export type Strategy = {
  label: string,
  value: number,
};

export const strategiesList: Strategy[] = [
  { label: "", value: 0 },
  // Special strategies
  { label: "When user goes online", value: 4 },
  { label: "When user get message", value: 5 },
  { label: "When user click on message", value: 6 },
  { label: "Scheduling based", value: 8 },
  // After subscription
  { label: "Exactly after subscription", value: 3 },
  { label: "5 minutes after subscription", value: 1 },
  { label: "10 minutes after subscription", value: 2 },
  { label: "11 minutes after subscription", value: 33 },
  { label: "12 minutes after subscription", value: 34 },
  { label: "13 minutes after subscription", value: 35 },
  { label: "14 minutes after subscription", value: 36 },
  { label: "15 minutes after subscription", value: 9 },
  { label: "16 minutes after subscription", value: 37 },
  { label: "17 minutes after subscription", value: 38 },
  { label: "18 minutes after subscription", value: 39 },
  { label: "19 minutes after subscription", value: 40 },
  { label: "20 minutes after subscription", value: 10 },
  { label: "21 minutes after subscription", value: 41 },
  { label: "22 minutes after subscription", value: 42 },
  { label: "23 minutes after subscription", value: 43 },
  { label: "24 minutes after subscription", value: 44 },
  { label: "25 minutes after subscription", value: 11 },
  { label: "26 minutes after subscription", value: 45 },
  { label: "27 minutes after subscription", value: 46 },
  { label: "28 minutes after subscription", value: 47 },
  { label: "29 minutes after subscription", value: 48 },
  { label: "30 minutes after subscription", value: 12 },
  { label: "31 minutes after subscription", value: 49 },
  { label: "32 minutes after subscription", value: 50 },
  { label: "33 minutes after subscription", value: 51 },
  { label: "34 minutes after subscription", value: 52 },
  { label: "35 minutes after subscription", value: 53 },
  { label: "36 minutes after subscription", value: 54 },
  { label: "37 minutes after subscription", value: 55 },
  { label: "38 minutes after subscription", value: 56 },
  { label: "39 minutes after subscription", value: 57 },
  { label: "40 minutes after subscription", value: 58 },
  { label: "41 minutes after subscription", value: 59 },
  { label: "42 minutes after subscription", value: 60 },
  { label: "43 minutes after subscription", value: 61 },
  { label: "44 minutes after subscription", value: 62 },
  { label: "45 minutes after subscription", value: 13 },
  { label: "46 minutes after subscription", value: 63 },
  { label: "47 minutes after subscription", value: 64 },
  { label: "48 minutes after subscription", value: 65 },
  { label: "49 minutes after subscription", value: 66 },
  { label: "50 minutes after subscription", value: 67 },
  { label: "51 minutes after subscription", value: 68 },
  { label: "52 minutes after subscription", value: 69 },
  { label: "53 minutes after subscription", value: 70 },
  { label: "54 minutes after subscription", value: 71 },
  { label: "55 minutes after subscription", value: 72 },
  { label: "56 minutes after subscription", value: 73 },
  { label: "57 minutes after subscription", value: 74 },
  { label: "58 minutes after subscription", value: 75 },
  { label: "59 minutes after subscription", value: 76 },
  { label: "60 minutes after subscription", value: 14 },
  { label: "24 hours after subscription", value: 7 },
  // After registration
  { label: "5 minutes after registration", value: 15 },
  { label: "10 minutes after registration", value: 16 },
  { label: "15 minutes after registration", value: 17 },
  { label: "20 minutes after registration", value: 18 },
  { label: "25 minutes after registration", value: 19 },
  { label: "30 minutes after registration", value: 20 },
  { label: "45 minutes after registration", value: 21 },
  { label: "60 minutes after registration", value: 22 },
  { label: "24 hours after registration", value: 23 },
  // After payment
  { label: "5 minutes after payment", value: 24 },
  { label: "10 minutes after payment", value: 25 },
  { label: "15 minutes after payment", value: 26 },
  { label: "20 minutes after payment", value: 27 },
  { label: "25 minutes after payment", value: 28 },
  { label: "30 minutes after payment", value: 29 },
  { label: "45 minutes after payment", value: 30 },
  { label: "60 minutes after payment", value: 31 },
  { label: "24 hours after payment", value: 32 },
];

export const messageGroupListItemToShort: (MessageGroupListItem) => MessageGroupShort = (messageGroup) => {
  const {
    name,
    isActive,
    browserLanguages,
    placements,
    sendStrategies,
    messages,
    tag,
  }: MessageGroupListItem = messageGroup;

  return {
    name,
    isActive,
    browserLanguages: browserLanguages.map((item: BrowserLanguage): string => item.id),
    placements,
    strategies: [
      (strategiesList.find((item: Strategy): boolean => item.label === sendStrategies) || {}).value
      || -1,
    ],
    messages: messages.map((item: MessageListItem): string => item.id),
    tag,
  };
};

export const messageGroupToListItem: (MessageGroup) => MessageGroupListItem = (messageGroup) => {
  const {
    id,
    name,
    isActive,
    messages,
    browserLanguages,
    placements,
    tag,
    sendStrategies,
    usedInCampaigns,
  }: MessageGroup = messageGroup;

  return {
    id,
    name,
    isActive,
    messages,
    browserLanguages,
    placements,
    tag,
    usedInCampaigns,
    sendStrategies: sendStrategies.name,
  };
};

export const messageGroupToViewItem: (MessageGroup) => MessageGroupViewItem = (messageGroup) => {
  const {
    id,
    name,
    isActive,
    rotationType,
    messages,
    browserLanguages,
    placements,
    tag,
    usedInCampaigns,
    sendStrategies,
  }: MessageGroup = messageGroup;

  return {
    id,
    name,
    isActive,
    rotationType,
    messages,
    browserLanguages,
    placements,
    tag,
    usedInCampaigns,
    sendStrategies: sendStrategies.name,
  };
};
